export interface RefundAvailability {
  chargeId: number
  participationId: number
  netAmount: number
  grossAmount: number
  refundedAmount: number
  refundableViaStripe: boolean
  paymentType: "manual" | "bulk_credit" | "bank_account" | "card"
}

export function findRefundAvailability(availabilities: RefundAvailability[], chargeId?: number, participationId?: number) {
  if (chargeId && participationId) {
    return availabilities.find((a) => a.chargeId === chargeId && a.participationId === participationId)
  }
}

export function maxRefundable(availability: RefundAvailability, includeFees: boolean): number {
  if (includeFees) {
    return availability.grossAmount - availability.refundedAmount
  } else {
    return availability.grossAmount - convenienceFees(availability) - availability.refundedAmount
  }
}

export function convenienceFees(availability: RefundAvailability): number {
  if (availability.grossAmount > availability.netAmount) {
    return availability.grossAmount - availability.netAmount
  } else {
    return 0
  }
}
